import {
  buildDetailItems,
  chunkItems,
  itemsPerRowByHeader,
  padRowWithPlaceholders,
  renderDetailItem,
} from "./utils/detailsHelpers";

export const HeaderDetailRows = ({ headerType, formHeader, dobWithAge }) => {
  const detailItems = buildDetailItems(headerType, formHeader, dobWithAge);
  const itemsPerRow = itemsPerRowByHeader[headerType] ?? 3;
  const gridColsClass = itemsPerRow === 2 ? "grid-cols-2" : "grid-cols-3";
  const rows = chunkItems(detailItems, itemsPerRow);

  return (
    <div className="flex min-w-[600px] max-w-[800px] flex-col gap-4">
      {rows.map((rowItems, rowIndex) => {
        const paddedRow = padRowWithPlaceholders(rowItems, itemsPerRow, rowIndex);

        return (
          <div key={`row-${rowIndex}`} className={`grid ${gridColsClass}`}>
            {paddedRow.map((item) => renderDetailItem(item))}
          </div>
        );
      })}
    </div>
  );
};
